import { Badge, TableCellContent } from '@billy/design-system'
import React, { ReactElement, ReactNode } from 'react'
import { useTranslation } from 'react-i18next'

import * as Styled from './styles'

interface BillDescriptionProps {
  children: ReactNode
  isCreditNote?: boolean
  title?: string
}

export const InvoiceDescription = ({ children, isCreditNote, title }: BillDescriptionProps): ReactElement => {
  const { t } = useTranslation()

  return (
    <Styled.InvoiceDescriptionWrapper>
      {isCreditNote && (
        <Styled.BadgeWrapper title={t('invoices.table.column.description.credit_note')}>
          <Badge color="warning" mode="subtle">
            {t('invoices.table.column.description.credit_note_abbreviation')}
          </Badge>
        </Styled.BadgeWrapper>
      )}
      <TableCellContent title={title} truncate>
        {children}
      </TableCellContent>
    </Styled.InvoiceDescriptionWrapper>
  )
}
